module.exports = __webpack_public_path__ + "img/GG.6c8e954b.svg";